module.exports = __webpack_public_path__ + "assets/d7c639084f684d66a1bc66855d193ed8.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./~/font-awesome/fonts/fontawesome-webfont.svg?v=4.6.3
 ** module id = 1765
 ** module chunks = 1
 **/